import Splide from '@splidejs/splide';
( function( app ) {
  const COMPONENT = {
    init: function() {
      $( '.brand-grid-slider' ).each( ( key, marquee ) => {
        new Splide( marquee, {
          destroy: true,
          type: 'slide',
          autoWidth: true,
          arrows: false,
          gap: '24px',
          breakpoints: {
            1024: {
              destroy: false,
            },
          },
          pagination: false,
        } ).mount();
      } );
    },
    finalize: function() {
    },
  };

  app.registerComponent( 'brand-grid', COMPONENT );
} )( app );
